import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Header.css';

function Header({ onOpenStats, onOpenAuth, onOpenHelp }) {
  const { isAuthenticated, user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => {
    logout();
    setShowUserMenu(false);
  };

  return (
    <header className="game-header">
      <div className="header-content">
        <div className="header-left">
          <h1>SKYLANDLE</h1>
          <div className="subtitle">Daily Mystery Skylander!</div>
        </div>
        
        <div className="header-right">
          <button className="header-btn help-btn" onClick={onOpenHelp} title="How to Play">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
            </svg>
          </button>

          <button className="header-btn stats-btn" onClick={onOpenStats} title="Statistics">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
              <path d="M3 7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7Z" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 11L8 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M16 13L16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M12 8L12 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          
          {isAuthenticated ? (
            <div className="user-menu">
              <button 
                className="header-btn user-btn" 
                onClick={() => setShowUserMenu(!showUserMenu)}
                title={user?.email}
              >
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor">
                  <path d="M10,9 C7.783496,9 5.980955,7.20598 5.980955,5 C5.980955,2.79398 7.783496,1 10,1 C12.216504,1 14.019045,2.79398 14.019045,5 C14.019045,7.20598 12.216504,9 10,9 M13.775893,9.67298 C15.370449,8.39598 16.299854,6.33098 15.958235,4.06998 C15.561354,1.44698 13.368965,-0.65202 10.722423,-0.95802 C7.070116,-1.38102 3.971432,1.44898 3.971432,5 C3.971432,6.88998 4.851603,8.57398 6.224107,9.67298 C2.852128,10.93398 0.390463,13.89498 0.004634,17.89098 C-0.051632,18.48198 0.411563,18.99998 1.008391,18.99998 C1.519814,18.99998 1.955881,18.61598 2.001095,18.10898 C2.404004,13.64598 5.837274,11 10,11 C14.162726,11 17.595996,13.64598 17.998905,18.10898 C18.044119,18.61598 18.480186,18.99998 18.991609,18.99998 C19.588437,18.99998 20.051632,18.48198 19.995366,17.89098 C19.609537,13.89498 17.147872,10.93398 13.775893,9.67298"/>
                </svg>
              </button>
              {showUserMenu && (
                <div className="user-dropdown">
                  <div className="user-email">{user?.email}</div>
                  <button onClick={handleLogout} className="logout-btn">
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button className="header-btn login-btn" onClick={onOpenAuth}>
              Login
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
